import * as util from './syllabus-block-utils';
import Block from './block';

export default {
  props: util.props,
  template: '#image-block-template',
  data() {
    return Object.assign({
      title: '',
      file: null,
      removeContent: false,
    }, this.rootData);
  },
  components: {
    Block
  },
  watch: {
    dataForSave() {
      this.$emit('block-update', this.dataForSave);
    },
  },
  computed: {
    isEmpty() {
      return _.isEmpty(this.file);
    },
    dataForSave() {
      return {
        uuid: this.uuid,
        data: {
          title: this.title,
          file: this.file,
          contentName: this.contentName,
          contentSize: this.contentSize,
          removeContent: this.removeContent,
          showOnPublicSyllabus: this.showOnPublicSyllabus
        }
      };
    },
    dzID: util.dzID
  },
  methods: {
    initDropzone() {
      const message = JST['templates/dropzone-generic']({
        maxFilesize: 10,
        optional: true,
        acceptedFiles: '.jpg, .jpeg, .png',
        dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
        dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
        browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
        dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
        maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
        fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
        optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
      });

      const opts = {
        maxFilesize: 10,
        dzPreview: JST['templates/dropzone-generic-img-preview']({
          previewable: true,
          containerClass: 'dz-preview-slim',
          nameLabel: Kadenze.I18n.t('file_preview.name'),
          sizeLabel: Kadenze.I18n.t('file_preview.size'),
          previewLabel: Kadenze.I18n.t('file_preview.preview'),
          removeLabel: Kadenze.I18n.t('file_preview.remove_file'),
          fileUploadProgressLabel: Kadenze.I18n.t('file_preview.file_upload_progress')
        }),
        previewable: true,
        acceptedFiles: '.jpg, .jpeg, .png',
        cropOptions: {
          modalId: 'crop_modal'
        },
        autoProcessQueue: false
      };

      const callbacks = {
        success: (file, { block }) => {
          this.bindFile(file, block);
          this.$emit('set-block-id', { uuid: this.uuid, id: block.id });
        },
        error: (file, errorMessage) => {
          new Kadenze.Notice.error({ message: errorMessage });
          this.$refs.dzEle.dropzone.removeAllFiles();
        },
        removedfile: () => {
          this.file = null;
          this.removeContent = true;
        }
      };


      this.dropzone = new Kadenze.ImageDropZone(
        this.$refs.dzEle,
        message,
        Kadenze.Routes.course_syllabus_blocks_path(this.$root.course.id),
        callbacks,
        this.curFileObj(),
        opts
      );
    },
    bindFile: util.bindFile,
    curFileObj: util.curFileObj
  },
  mounted() {
    this.initDropzone();
  },
};
